import React, { useState, useEffect } from "react";
import "../styles/contactus.css";
import { FaFacebook, FaTwitter, FaInstagram } from "react-icons/fa";
import { API_URL } from "../variables";
import { toast, ToastContainer } from "react-toastify";
import { useSelector } from "react-redux";

const ContactUs = () => {
  const { settings } = useSelector((state) => state.site);
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    message: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Basic validation
    if (
      !formData.name.trim() ||
      !formData.email.trim() ||
      !formData.phone.trim() ||
      !formData.message.trim()
    ) {
      toast.error("Please fill in all fields");
      return;
    }

    // Email validation
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(formData.email)) {
      toast.error("Please enter a valid email address");
      return;
    }

    // Phone validation (basic format check)
    const phoneRegex = /^[\+]?[0-9\s\-\(\)]{10,}$/;
    if (!phoneRegex.test(formData.phone)) {
      toast.error("Please enter a valid phone number");
      return;
    }

    try {
      const response = await fetch(`${API_URL}/api/users/contact`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      });
      const data = await response.json();

      if (response.ok) {
        toast.success("Message sent successfully! We'll get back to you soon.");
        // Clear the form after successful submission
        setFormData({
          name: "",
          email: "",
          phone: "",
          message: "",
        });
      } else {
        toast.error(
          data.message || "Failed to send message. Please try again."
        );
      }
    } catch (error) {
      console.error("Error submitting form:", error);
      toast.error("Network error. Please check your connection and try again.");
    }
  };

  useEffect(() => {
    document.title = "Contact Us";
  }, []);

  return (
    <div className="contact-us-container">
      <ToastContainer />
      <div className="contact-info green-bg">
        <h2>Contact Information</h2>
        <p>Phone: {settings.phone}</p>
        <p>Email: {settings.email}</p>
        <p>Address: {settings.address}</p>
        <h3>Follow Us</h3>
        <ul className="social-links">
          <li>
            <a href={settings.facebook} target="_blank" rel="noreferrer">
              <FaFacebook /> {settings.facebook}
            </a>
          </li>
          <li>
            <a href={settings.twitter} target="_blank" rel="noreferrer">
              <FaTwitter /> {settings.twitter}
            </a>
          </li>
          <li>
            <a href={settings.instagram} target="_blank" rel="noreferrer">
              <FaInstagram /> {settings.instagram}
            </a>
          </li>
        </ul>
      </div>

      <div className="contact-form">
        <h2>Get in Touch with us!</h2>
        <p>
          Any question or remarks? Want to order? Just write us a message and
          we'll get back to you shortly!
        </p>
        <form onSubmit={handleSubmit}>
          <div className="contact-form-group">
            <label htmlFor="name">Your Name:</label>
            <input
              type="text"
              id="name"
              name="name"
              value={formData.name}
              onChange={handleChange}
              required
            />
          </div>

          <div className="contact-form-group">
            <label htmlFor="email">Your Email:</label>
            <input
              type="email"
              id="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              required
            />
          </div>
          <div className="contact-form-group">
            <label htmlFor="phone">Your Phone:</label>
            <input
              type="tel"
              id="phone"
              name="phone"
              value={formData.phone}
              onChange={handleChange}
              required
            />
          </div>

          <div className="contact-form-group">
            <label htmlFor="inquiry">Your Inquiry:</label>
            <textarea
              id="message"
              name="message"
              value={formData.message}
              onChange={handleChange}
              required
            ></textarea>
          </div>

          <button type="submit" className="contact-submit-btn">
            Submit
          </button>
        </form>
      </div>
    </div>
  );
};

export default ContactUs;
